import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['content'];

  connect() {
    this._originalHtml = this.contentTarget.innerHTML;
    this._boundSwap = this._swap.bind(this);
    document.addEventListener('promote:content-page-swap', this._boundSwap);
  }

  disconnect() {
    document.removeEventListener('promote:content-page-swap', this._boundSwap);
  }

  restore() {
    this.contentTarget.innerHTML = this._originalHtml;

    const aside = document.getElementById('js-aside');
    if (aside) aside.style.display = '';

    const navSidebar = document.getElementById('js-quiz-nav-sidebar');
    if (navSidebar) {
      navSidebar.classList.add('hidden');
      navSidebar.innerHTML = '';
    }
  }

  _swap(event) {
    const { html, navSidebarHtml } = event.detail || {};
    if (typeof html !== 'string') return;

    this.contentTarget.innerHTML = html;

    const aside = document.getElementById('js-aside');
    if (aside) aside.style.display = 'none';

    const navSidebar = document.getElementById('js-quiz-nav-sidebar');
    if (navSidebar && typeof navSidebarHtml === 'string') {
      navSidebar.innerHTML = navSidebarHtml;
      navSidebar.classList.remove('hidden');
    }
  }
}
